import { useLayoutEffect, useState } from 'react';

export interface ScrollableDataTableFixedItems {
	height: number;
	width: number;
}
export default function useScrollableDataTableFixedItems({
	ref,
	firstColumnFixed,
}: {
	ref: any;
	firstColumnFixed: boolean;
}) {
	const [fixedItems, setFixedItems] =
		useState<ScrollableDataTableFixedItems[]>();

	useLayoutEffect(() => {
		if (firstColumnFixed) {
			const rows = ref?.current?.children;
			const items: ScrollableDataTableFixedItems[] = [];
			for (const row of rows) {
				const firstCol = row?.children[0];
				if (firstCol) {
					items.push({
						height: firstCol.clientHeight,
						width: firstCol.clientWidth + 2,
					});
				}
			}
			setFixedItems(items);
		}
	}, [firstColumnFixed]);

	return { fixedItems };
}
